<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Ajuda
        <v-spacer></v-spacer>
        <v-btn icon @click="visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <div v-html="content"></div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="visible = false">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GlobalHelpDialog',
  data() {
    return {
      visible: false,
      content: ''
    };
  },
  mounted() {
    this.$root.$on('show-global-help', this.show);
  },
  beforeDestroy() {
    this.$root.$off('show-global-help', this.show);
  },
  methods: {
    show(content) {
      this.content = content;
      this.visible = true;
    }
  }
};
</script>
